/**
 * Cliente del agente local Printify (Electron en esta PC).
 * Solo habla con 127.0.0.1; no pasa por el API de Puestify ni envía el JWT.
 */

import { API_BASE_URL } from '@/config/api';

export const PRINTIFY_PORT = 18765;
export const PRINTIFY_ORIGIN = `http://127.0.0.1:${PRINTIFY_PORT}`;

export const PRINTIFY_DESTINOS = {
    ticket: 'ticket',
    fiscal: 'fiscal',
    comanda: 'comanda',
};

export function isPrintifyMotor(ticketCfg) {
    return String((ticketCfg && ticketCfg.motor_impresion) || '').trim().toLowerCase() === 'printify';
}

export function parseMotorImpresion(raw) {
    return String(raw || '').trim().toLowerCase() === 'printify' ? 'printify' : 'kiosk';
}

export function printifyInstallerUrl(arch) {
    const key = String(arch || 'x64').toLowerCase() === 'ia32' ? 'ia32' : 'x64';
    return `${API_BASE_URL}/downloads/printify/${key}`;
}

async function printifyFetch(path, { method = 'GET', body, timeoutMs = 8000 } = {}) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
        const res = await fetch(`${PRINTIFY_ORIGIN}${path}`, {
            method,
            signal: ctrl.signal,
            headers: {
                Accept: 'application/json',
                ...(body ? { 'Content-Type': 'application/json' } : {}),
            },
            body: body ? JSON.stringify(body) : undefined,
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const err = new Error(data.message || data.error || `Printify respondió ${res.status}.`);
            err.code = data.code || 'PRINTIFY_HTTP';
            err.status = res.status;
            throw err;
        }
        return data;
    } catch (e) {
        if (e && e.code === 'PRINTIFY_HTTP') throw e;
        if (e && (e.name === 'AbortError' || e.code === 'ABORT_ERR')) {
            const err = new Error('Printify no respondió a tiempo. ¿Está abierto en esta PC?');
            err.code = 'PRINTIFY_TIMEOUT';
            throw err;
        }
        const err = new Error('No se pudo conectar con Printify. Abrí el programa en esta PC (puerto 18765).');
        err.code = 'PRINTIFY_DOWN';
        err.cause = e;
        throw err;
    } finally {
        clearTimeout(timer);
    }
}

export async function printifyHealth() {
    return printifyFetch('/health', { timeoutMs: 2500 });
}

export async function printifyPrint({ destino, html, widthMm, copies = 1, jobName }) {
    const dest = PRINTIFY_DESTINOS[destino] || PRINTIFY_DESTINOS.ticket;
    return printifyFetch('/print', {
        method: 'POST',
        timeoutMs: 25000,
        body: {
            destino: dest,
            html,
            widthMm: Number(widthMm) || 80,
            copies: Math.max(1, Math.min(5, Number(copies) || 1)),
            jobName: jobName || `Puestify ${dest}`,
        },
    });
}
